var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorUnplugged = function SvgErrorUnplugged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9ea7a9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m177.906 156.976-20.93 20.93-18.837-14.652 25.116-25.113zM81.627 64.885 90 56.512l20.93 20.93a5.921 5.921 0 0 1-8.373 8.372zM56.512 90l8.37-8.37 20.932 20.93a5.917 5.917 0 0 1 0 8.37 5.92 5.92 0 0 1-8.373 0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#717679",
    d: "M0 8.37 8.373 0l8.373 8.37-8.373 8.374z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ea7a9",
    d: "m2.093 23.024 20.93-20.93L41.86 16.746 16.744 41.859z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e5356",
    d: "M41.86 87.906 87.908 41.86a5.92 5.92 0 1 1 8.373 8.373L50.234 96.28a5.92 5.92 0 1 1-8.373-8.373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#717679",
    d: "m18.24 40.366 22.124-22.128c4.385-4.382 11.409-4.643 16.104-.593L87.906 41.86 41.86 87.905 17.644 56.467a11.834 11.834 0 0 1 .596-16.101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ea7a9",
    d: "m41.32 46.588 5.266-5.266c5.48-5.484 14.369-5.484 19.85 0l11.007 11.005L52.324 77.44 41.319 66.438c-5.48-5.484-5.48-14.37 0-19.85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#717679",
    d: "m180 171.629-8.373 8.37-8.373-8.37 8.373-8.373zM147.907 173.335a3.1 3.1 0 0 1-2.194-.909 3.1 3.1 0 0 1 0-4.388l6.976-6.976a3.1 3.1 0 0 1 4.389 0 3.1 3.1 0 0 1 0 4.388l-6.977 6.976a3.1 3.1 0 0 1-2.194.909M163.257 157.988a3.1 3.1 0 0 1-2.194-.909 3.1 3.1 0 0 1 0-4.388l6.976-6.977a3.1 3.1 0 0 1 4.388 0 3.1 3.1 0 0 1 0 4.388l-6.976 6.977c-.605.605-1.4.909-2.194.909"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e5356",
    d: "M138.14 92.094 92.094 138.14a5.921 5.921 0 0 1-8.374-8.373l46.046-46.046a5.922 5.922 0 0 1 8.374 8.373"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#717679",
    d: "m161.761 139.634-22.125 22.128c-4.385 4.382-11.408 4.642-16.103.592l-31.438-24.213 46.045-46.046 24.217 31.438a11.834 11.834 0 0 1-.596 16.101"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ea7a9",
    d: "m138.742 133.351-5.388 5.388c-5.45 5.449-14.282 5.449-19.729 0l-11.066-11.064 25.116-25.116 11.067 11.067c5.446 5.446 5.446 14.279 0 19.725"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#717679",
    d: "M25.118 19.848c-.795 0-1.59-.304-2.194-.91a3.1 3.1 0 0 1 0-4.387L29.9 7.574a3.1 3.1 0 0 1 4.389 0 3.1 3.1 0 0 1 0 4.388l-6.977 6.977c-.605.605-1.4.909-2.194.909M9.768 35.196c-.794 0-1.589-.304-2.194-.91a3.1 3.1 0 0 1 0-4.387l6.977-6.977a3.1 3.1 0 0 1 4.388 0 3.1 3.1 0 0 1 0 4.388l-6.976 6.977c-.606.605-1.4.909-2.195.909"
  })));
};
export default SvgErrorUnplugged;